/**
 * CA affiché pour une ligne top produit (dashboard / analytics).
 */
export function resolveProductLineCa(item) {
  const sum = item._sum || {};
  const fromSum = Number(sum.prixTotal);
  if (Number.isFinite(fromSum) && fromSum > 0) return fromSum;

  const fromCa = Number(item.ca);
  if (Number.isFinite(fromCa) && fromCa > 0) return fromCa;

  const qty = Number(item.quantite ?? sum.quantite ?? 0);
  const unit = Number(item.produit?.prix ?? 0);
  if (qty > 0 && unit > 0) return qty * unit;

  return 0;
}

export function formatEuro(amount) {
  return Number(amount || 0).toFixed(2).replace('.', ',') + '€';
}

export function formatUptime(seconds) {
  const total = Number(seconds) || 0;
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  if (days > 0) return `${days} j ${hours} h`;
  if (hours > 0) return `${hours} h ${minutes} min`;
  return `${minutes} min`;
}
